"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var prismjs_1 = __importDefault(require("prismjs"));
var components_1 = __importDefault(require("prismjs/components/"));
var DEFAULTS = {
    plugins: [],
    init: function () {
        // do nothing by default
    },
};
/**
 * Loads the provided {@code lang} into prism.
 *
 * @param lang
 *        Code of the language to load.
 * @return The Prism language object for the provided {@code lang} code. {@code undefined} if the language is not known to Prism.
 */
function loadPrismLang(lang) {
    if (!lang)
        return undefined;
    var langObject = prismjs_1.default.languages[lang];
    if (langObject === undefined) {
        components_1.default([lang]);
        langObject = prismjs_1.default.languages[lang];
    }
    return langObject;
}
/**
 * Select the language to use for highlighting, based on the provided options and the specified language.
 *
 * @param options
 *        The options that were used to initialise the plugin.
 * @param lang
 *        Code of the language to highlight the text in.
 * @return  The name of the language to use and the Prism language object for that language.
 */
function selectLanguage(lang) {
    var langToUse = lang === null || lang === void 0 ? void 0 : lang.toLowerCase();
    var prismLang = loadPrismLang(langToUse);
    return [langToUse, prismLang];
}
/**
 * Highlights the provided text using Prism.
 *
 * @param markdownit
 *        The markdown-it instance
 * @param options
 *        The options that have been used to initialise the plugin.
 * @param text
 *        The text to highlight.
 * @param lang
 *        Code of the language to highlight the text in.
 * @return {@code text} wrapped in {@code &lt;pre&gt;} and {@code &lt;code&gt;}, both equipped with the appropriate class
 *  (markdown-it’s langPrefix + lang). If Prism knows {@code lang}, {@code text} will be highlighted by it.
 */
function highlight(markdownit, text, lang) {
    var _a = selectLanguage(lang), langToUse = _a[0], prismLang = _a[1];
    var code = prismLang
        ? prismjs_1.default.highlight(text, prismLang, langToUse)
        : markdownit.utils.escapeHtml(text);
    var classAttribute = langToUse
        ? " class=\"" + markdownit.options.langPrefix + markdownit.utils.escapeHtml(langToUse) + "\""
        : "";
    return "<pre" + classAttribute + "><code" + classAttribute + ">" + code + "</code></pre>";
}
/**
 * Initialisation function of the plugin. This function is not called directly by clients, but is rather provided
 * to MarkdownIt’s {@link MarkdownIt.use} function.
 *
 * @param markdownit
 *        The markdown it instance the plugin is being registered to.
 * @param useroptions
 *        The options this plugin is being initialised with.
 */
function markdownItPrism(markdownit, useroptions) {
    var options = Object.assign({}, DEFAULTS, useroptions);
    options.init(prismjs_1.default);
    // register ourselves as highlighter
    markdownit.options.highlight = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return highlight.apply(void 0, __spreadArrays([markdownit], args));
    };
}
exports.default = markdownItPrism;
